// One stylesheet for the whole public site. Every selector is scoped under
// .dk so none of it can reach the admin panel's MUI theme.
const css = `
.dk{
  --bg:#070d16; --bg-2:#0c1523; --card:#111d2f; --card-2:#16263c;
  --gold:#f5b43c; --gold-2:#ffd07a; --green:#2fd07f; --red:#ff6b5e;
  --ink:#eef4fa; --muted:#8ba2b8; --line:rgba(245,180,60,.16);
  --r:14px; --max:1180px;
  background:
    radial-gradient(900px 480px at 12% -8%, rgba(245,180,60,.10), transparent 60%),
    radial-gradient(700px 400px at 92% 4%, rgba(47,208,127,.07), transparent 60%),
    var(--bg);
  color:var(--ink); min-height:100vh;
  font:16px/1.6 ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
  -webkit-font-smoothing:antialiased;
}
.dk *{box-sizing:border-box}
.dk a{color:inherit;text-decoration:none}
.dk .wrap{max-width:var(--max);margin:0 auto;padding:0 18px}

/* header */
.dk .hdr{position:sticky;top:0;z-index:60;background:rgba(7,13,22,.9);backdrop-filter:blur(12px);border-bottom:1px solid rgba(255,255,255,.07)}
.dk .hdr-in{display:flex;align-items:center;justify-content:space-between;gap:16px;height:64px}
.dk .brand{display:flex;align-items:center;gap:10px;font-weight:800;font-size:17px;white-space:nowrap}
.dk .logo{width:34px;height:34px;border-radius:10px;display:grid;place-items:center;font-weight:900;font-size:13px;
  background:linear-gradient(145deg,var(--gold-2),var(--gold));color:#2b1a00}
.dk .nav{display:flex;gap:4px;align-items:center;overflow-x:auto;scrollbar-width:none}
.dk .nav::-webkit-scrollbar{display:none}
.dk .nav a{padding:8px 13px;border-radius:9px;font-size:14.5px;color:var(--muted);white-space:nowrap;font-weight:600}
.dk .nav a:hover{color:var(--ink);background:rgba(255,255,255,.05)}
.dk .nav a.on{color:#2b1a00;background:linear-gradient(145deg,var(--gold-2),var(--gold))}

/* generic */
.dk .page{padding:34px 0 70px}
.dk h1{font-size:clamp(26px,4vw,40px);line-height:1.12;margin:0 0 10px;letter-spacing:-.02em}
.dk h2{font-size:clamp(20px,2.6vw,27px);margin:0 0 6px;letter-spacing:-.01em}
.dk .lede{color:var(--muted);margin:0 0 26px;max-width:62ch}
.dk .eyebrow{color:var(--gold);font-weight:800;font-size:12px;letter-spacing:.16em;text-transform:uppercase}
.dk .card{background:linear-gradient(180deg,var(--card),var(--card-2));border:1px solid rgba(255,255,255,.08);border-radius:var(--r)}
.dk .btn{display:inline-flex;align-items:center;gap:8px;justify-content:center;padding:12px 22px;border-radius:999px;
  font-weight:700;font-size:15px;border:0;cursor:pointer;
  background:linear-gradient(180deg,var(--gold-2),var(--gold));color:#2b1a00;
  box-shadow:0 8px 22px rgba(245,180,60,.24);transition:transform .15s,box-shadow .15s}
.dk .btn:hover{transform:translateY(-2px);box-shadow:0 12px 28px rgba(245,180,60,.34)}
.dk .btn.ghost{background:transparent;color:var(--gold);border:1.5px solid var(--gold);box-shadow:none}
.dk .pill{display:inline-flex;align-items:center;gap:7px;font-size:11.5px;font-weight:800;padding:4px 11px;border-radius:999px;letter-spacing:.03em}
.dk .pill.open{color:#0b3d27;background:#8ff0c0}
.dk .pill.shut{color:#4d1410;background:#ffb3ab}
.dk .dot{width:6px;height:6px;border-radius:50%;background:currentColor}

/* toolbar */
.dk .bar{display:flex;gap:12px;align-items:center;flex-wrap:wrap;margin-bottom:20px}
.dk input[type=date],.dk select{background:var(--card);color:var(--ink);border:1px solid rgba(255,255,255,.14);
  border-radius:10px;padding:10px 13px;font:inherit;font-size:14.5px;color-scheme:dark}
.dk .chip{padding:8px 14px;border-radius:999px;border:1px solid var(--line);background:rgba(245,180,60,.07);
  color:var(--muted);font-size:13.5px;font-weight:600;cursor:pointer}
.dk .chip.on{background:linear-gradient(145deg,var(--gold-2),var(--gold));color:#2b1a00;border-color:transparent}

/* market grid */
.dk .grid{display:grid;gap:14px}
.dk .g3{grid-template-columns:repeat(3,1fr)}
.dk .g4{grid-template-columns:repeat(4,1fr)}
@media(max-width:980px){.dk .g3,.dk .g4{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.dk .g3,.dk .g4{grid-template-columns:1fr}}
.dk .mkt{padding:16px 18px}
.dk .mkt .top{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:10px}
.dk .mkt .nm{font-weight:800;font-size:15px;letter-spacing:.02em}
.dk .num{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:23px;font-weight:700;
  letter-spacing:2px;color:var(--gold);text-align:center;margin:6px 0}
.dk .tm{font-size:12.5px;color:var(--muted);display:flex;justify-content:space-between;gap:10px}

/* table */
.dk .tbl-wrap{overflow-x:auto;border-radius:var(--r);border:1px solid rgba(255,255,255,.08)}
.dk table{width:100%;border-collapse:collapse;min-width:520px;background:var(--card)}
.dk th{text-align:left;font-size:11.5px;letter-spacing:.1em;text-transform:uppercase;color:var(--muted);
  padding:13px 16px;border-bottom:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.03);font-weight:800}
.dk td{padding:13px 16px;border-bottom:1px solid rgba(255,255,255,.05);font-size:14.5px}
.dk tr:last-child td{border-bottom:0}
.dk tbody tr:hover{background:rgba(255,255,255,.028)}
.dk .mono{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;letter-spacing:1px;color:var(--gold);font-weight:700}
.dk .win{color:var(--green);font-weight:800}

.dk .empty{padding:48px 20px;text-align:center;color:var(--muted)}
.dk .skel{height:82px;border-radius:var(--r);background:linear-gradient(90deg,var(--card),var(--card-2),var(--card));
  background-size:200% 100%;animation:dksk 1.2s infinite}
@keyframes dksk{0%{background-position:200% 0}100%{background-position:-200% 0}}

/* footer */
.dk .ftr{border-top:1px solid rgba(255,255,255,.07);padding:34px 0 44px;color:var(--muted);font-size:14px;margin-top:40px}
.dk .ftr-in{display:flex;justify-content:space-between;gap:26px;flex-wrap:wrap;margin-bottom:22px}
.dk .ftr a:hover{color:var(--gold)}
.dk .ftr h4{color:var(--ink);font-size:13.5px;margin:0 0 10px}
.dk .ftr ul{list-style:none;margin:0;padding:0;display:grid;gap:7px}
.dk .age{display:inline-grid;place-items:center;width:30px;height:30px;border-radius:50%;
  border:2px solid var(--gold);color:var(--gold);font-weight:800;font-size:11px}
.dk .note{border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.03);border-radius:var(--r);padding:22px}
.dk .note p{margin:0 0 8px;font-size:13.5px;color:var(--muted)}
.dk .note p:last-child{margin:0}

/* app preview */
.dk .hero-grid{display:grid;grid-template-columns:1.05fr .95fr;gap:48px;align-items:center}
@media(max-width:940px){.dk .hero-grid{grid-template-columns:1fr;gap:34px}}
.dk .phone{justify-self:center;width:300px;max-width:100%;border-radius:36px;padding:11px;
  background:linear-gradient(160deg,#1d3550,#0a1626);border:1px solid rgba(245,180,60,.22);
  box-shadow:0 34px 80px rgba(0,0,0,.6)}
.dk .phone-scr{border-radius:27px;background:#f3f6fa;color:#0d2436;overflow:hidden;display:flex;flex-direction:column;height:540px}
.dk .phone-bar{background:#0c1523;color:#fff;padding:13px 15px;display:flex;justify-content:space-between;align-items:center;
  font-size:13px;font-weight:800;flex:0 0 auto}
.dk .phone-bal{background:linear-gradient(145deg,var(--gold-2),var(--gold));color:#2b1a00;border-radius:999px;padding:3px 11px;font-size:11.5px}
.dk .phone-list{overflow:hidden;padding:8px;display:grid;gap:8px;align-content:start}
.dk .prow{background:#fff;border-radius:13px;padding:11px 13px;box-shadow:0 1px 6px rgba(13,36,54,.09)}
.dk .prow .r1{display:flex;justify-content:space-between;align-items:center;gap:8px}
.dk .prow .nm2{font-size:12.5px;font-weight:800;letter-spacing:.02em;color:#0d2436}
.dk .prow .st{font-size:9.5px;font-weight:800;padding:2px 8px;border-radius:999px}
.dk .prow .st.o{color:#0a7d55;background:#e3f7ee}
.dk .prow .st.c{color:#a3341f;background:#fdeae5}
.dk .prow .n2{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:15px;font-weight:700;
  letter-spacing:1.5px;color:#0c1523;margin-top:4px}
.dk .prow .t2{font-size:10px;color:#6b8298;margin-top:2px}
.dk .cap{text-align:center;font-size:12.5px;color:var(--muted);margin-top:12px}

/* ---------- mobile ---------- */
@media(max-width:640px){
  .dk .wrap{padding:0 14px}
  .dk .page{padding:22px 0 90px}
  .dk h1{font-size:27px}
  .dk .lede{font-size:15px;margin-bottom:18px}
  .dk .hdr-in{height:56px}
  .dk .brand{font-size:15px}
  .dk .logo{width:30px;height:30px;font-size:12px}
  .dk .nav a{padding:7px 11px;font-size:13.5px}
  .dk .grid{gap:10px}
  .dk .mkt{padding:13px 14px}
  .dk .num{font-size:20px;margin:4px 0}

  /* Tables become stacked cards. On a phone the last columns were being cut
     off inside a side-scrolling box, which hid the actual result numbers. */
  .dk .tbl-wrap{border:0;overflow:visible;border-radius:0}
  .dk table{min-width:0;background:transparent;display:block}
  .dk thead{display:none}
  .dk tbody{display:grid;gap:10px}
  .dk tr{display:block;background:linear-gradient(180deg,var(--card),var(--card-2));
    border:1px solid rgba(255,255,255,.08);border-radius:var(--r);padding:12px 14px}
  .dk td{display:flex;justify-content:space-between;align-items:center;gap:14px;
    padding:6px 0;border:0;font-size:14px}
  .dk td::before{content:attr(data-label);color:var(--muted);font-size:11.5px;
    font-weight:800;letter-spacing:.08em;text-transform:uppercase;flex:0 0 auto}
  .dk td:first-child{padding-top:0;font-size:15px}
  .dk td:last-child{padding-bottom:0}
  .dk tbody tr:hover{background:linear-gradient(180deg,var(--card),var(--card-2))}
}

/* result not declared yet */
.dk .await{color:var(--muted);font-size:13px;font-weight:700;letter-spacing:.02em}

/* section header */
.dk .sec-hd{display:flex;justify-content:space-between;align-items:baseline;gap:10px;flex-wrap:wrap;margin-bottom:14px}
.dk .sec-hd a{color:var(--gold);font-weight:700;font-size:14px}
.dk .more{display:block;text-align:center;padding:13px;margin-top:12px;border-radius:var(--r);
  border:1px solid var(--line);background:rgba(245,180,60,.06);color:var(--gold);font-weight:700;font-size:14.5px}

/* hamburger */
.dk .burger{display:none;background:transparent;border:1px solid rgba(255,255,255,.16);border-radius:10px;
  width:40px;height:40px;cursor:pointer;align-items:center;justify-content:center;flex:0 0 auto}
.dk .burger span{display:block;width:17px;height:2px;background:var(--ink);border-radius:2px;position:relative}
.dk .burger span::before,.dk .burger span::after{content:"";position:absolute;left:0;width:17px;height:2px;
  background:var(--ink);border-radius:2px;transition:transform .2s,top .2s}
.dk .burger span::before{top:-6px}.dk .burger span::after{top:6px}
.dk .burger.on span{background:transparent}
.dk .burger.on span::before{top:0;transform:rotate(45deg)}
.dk .burger.on span::after{top:0;transform:rotate(-45deg)}
.dk .drawer{display:none}
@media(max-width:760px){
  .dk .burger{display:flex}
  .dk .hdr .nav{display:none}
  .dk .drawer{display:block;overflow:hidden;max-height:0;transition:max-height .26s ease;
    border-top:1px solid rgba(255,255,255,0)}
  .dk .drawer.open{max-height:340px;border-top-color:rgba(255,255,255,.08)}
  .dk .drawer nav{display:grid;gap:4px;padding:10px 14px 14px}
  .dk .drawer a{padding:12px 14px;border-radius:10px;font-weight:700;font-size:15px;color:var(--muted)}
  .dk .drawer a.on{color:#2b1a00;background:linear-gradient(145deg,var(--gold-2),var(--gold))}
}

.dk .soon{margin:16px auto 0;max-width:420px;font-size:14px;color:var(--gold);
  background:rgba(245,180,60,.09);border:1px solid var(--line);border-radius:12px;padding:12px 16px}
.dk .soon a{text-decoration:underline}

/* fixed bottom download bar */
.dk .dlbar{position:fixed;left:0;right:0;bottom:0;z-index:70;
  background:rgba(7,13,22,.94);backdrop-filter:blur(14px);
  border-top:1px solid rgba(245,180,60,.2);
  padding:10px 14px calc(10px + env(safe-area-inset-bottom));
  display:flex;gap:12px;align-items:center;justify-content:space-between}
.dk .dlbar .txt{font-size:13px;color:var(--muted);line-height:1.35}
.dk .dlbar .txt b{display:block;color:var(--ink);font-size:14.5px}
.dk .dlbar .btn{padding:11px 20px;font-size:14.5px;flex:0 0 auto}
@media(min-width:761px){.dk .dlbar{justify-content:center;gap:20px}}
/* keep the bar from covering the last of the page */
.dk .ftr{padding-bottom:120px}

/* download progress dialog */
.dk .dlmodal{position:fixed;inset:0;z-index:90;display:flex;align-items:center;
  justify-content:center;padding:18px;background:rgba(3,7,13,.72);
  backdrop-filter:blur(4px);animation:dkfade .18s ease}
.dk .dlmodal-card{position:relative;width:min(430px,100%);max-height:90vh;
  overflow-y:auto;background:#122033;border:1px solid var(--line);
  border-radius:16px;padding:24px 22px 22px;
  box-shadow:0 22px 60px rgba(0,0,0,.6);animation:dkrise .22s ease}
.dk .dlmodal-card h3{margin:0 0 16px;font-size:18px;color:var(--ink)}
.dk .dlmodal-x{position:absolute;top:10px;right:12px;width:32px;height:32px;
  border:0;border-radius:50%;background:transparent;color:var(--muted);
  font-size:23px;line-height:1;cursor:pointer}
.dk .dlmodal-x:hover{background:rgba(255,255,255,.08);color:var(--ink)}
.dk .dlbar-track{height:9px;border-radius:999px;overflow:hidden;
  background:rgba(255,255,255,.1)}
.dk .dlbar-fill{height:100%;border-radius:999px;
  background:linear-gradient(90deg,var(--gold-2),var(--gold));
  transition:width .25s ease}
/* No total to measure against, so the bar sweeps instead of filling. */
.dk .dlbar-fill.indet{width:40%;animation:dksweep 1.1s ease-in-out infinite}
.dk .dlmodal-num{margin:10px 0 0;font-size:14px;color:var(--gold);
  font-variant-numeric:tabular-nums}
.dk .dlsteps{margin:16px 0 0;padding-left:20px;color:var(--muted);font-size:14px;
  line-height:1.55}
.dk .dlsteps li{margin-bottom:9px}
.dk .dlsteps b{color:var(--ink)}
.dk .dlnote{margin:14px 0 0;font-size:13px;color:var(--muted);line-height:1.5}
.dk .dlnote a{color:var(--gold);text-decoration:underline}
.dk .dlmodal-card .btn{margin-top:18px;width:100%}
@keyframes dkfade{from{opacity:0}to{opacity:1}}
@keyframes dkrise{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
@keyframes dksweep{0%{margin-left:-40%}100%{margin-left:100%}}
.dk .drawer .dl-item{margin-top:6px;text-align:center;color:#2b1a00;
  background:linear-gradient(145deg,var(--gold-2),var(--gold));font-weight:800}

/* hero call to action */
.dk .hero-cta{display:flex;flex-direction:column;align-items:center;gap:12px;
  margin:30px 0 34px;text-align:center}
.dk .hero-sub{font-size:13px;color:var(--muted);letter-spacing:.04em}
.dk .btn-hero{font-size:19px;font-weight:800;padding:19px 46px;letter-spacing:.01em;
  border-radius:999px;position:relative;
  box-shadow:0 12px 34px rgba(245,180,60,.42),0 0 0 0 rgba(245,180,60,.55);
  animation:dkpulse 2.4s ease-out infinite}
.dk .btn-hero:hover{transform:translateY(-3px);box-shadow:0 18px 44px rgba(245,180,60,.52)}
.dk .btn-hero .dl-ic{font-size:21px;line-height:1}
@keyframes dkpulse{
  0%{box-shadow:0 12px 34px rgba(245,180,60,.42),0 0 0 0 rgba(245,180,60,.5)}
  70%{box-shadow:0 12px 34px rgba(245,180,60,.42),0 0 0 18px rgba(245,180,60,0)}
  100%{box-shadow:0 12px 34px rgba(245,180,60,.42),0 0 0 0 rgba(245,180,60,0)}
}
@media(prefers-reduced-motion:reduce){.dk .btn-hero{animation:none}}

/* roomier spacing */
.dk .wrap{padding-left:24px;padding-right:24px}
.dk .page{padding-top:46px;padding-bottom:80px}
.dk section{padding:56px 0}
.dk h1{margin-bottom:16px}
.dk .lede{margin-bottom:8px;line-height:1.7}
.dk .stats{margin-top:34px;gap:40px}
.dk .sec-hd{margin-bottom:20px}
.dk .grid{gap:16px}
.dk .mkt{padding:18px 20px}
@media(max-width:640px){
  .dk .wrap{padding-left:18px;padding-right:18px}
  .dk .page{padding-top:30px;padding-bottom:100px}
  .dk section{padding:38px 0}
  .dk .hero-cta{margin:26px 0 30px}
  .dk .btn-hero{font-size:17px;padding:17px 38px;width:100%;max-width:330px}
  .dk .grid{gap:12px}
  .dk .mkt{padding:15px 16px}
}
`;
export default css;
